module.exports = __webpack_public_path__ + "img/avatar.c9e6a0b3.jpg";